module.exports = __webpack_public_path__ + "assets/3e8ec013f54616767965d2c8aad1b890.png";